export const formItemProps = {
    colon: false,
    labelAlign: 'left'
};
export const reg = /^\d{5,10}$/;
export const reg9 = /^9\d{3,11}$/;
export const regPhone = /^1[3456789]\d{9}$/;
export const regTel = /^0\d{2,3}-\d{7,8}$/;
export const reg400800 = /^(4|8)./;

/* eslint-disable */
export function checkNumber(value) {
    const reg = /(^(400|800)-\d{3}-\d{4}$)|(^(400|800)-\d{4}-\d{3}$)|(^(400|800)\d{1}-\d{3}-\d{3}$)|(^(1[3456789]\d{9})$)|(^0[\d]{2,3}\-?[\d]{3,}$)|(^1010\-?\d{4}$)|(^1\d{4}$)|(^(0[\d]{2,3}\-?)?(95|96)\d{3,11}$)/;
    return reg.test(value);
}
/* eslint-enable */
